import type { RefObject } from 'react';

import { isFunction } from 'lodash-es';

import type { MetadataValues } from '@iconik-io/iconik-api/src/schema_patched/metadata';

import type { FCC } from '../../types/common';
import Form from '../../ui/forms/form';

type Props = {
  onSubmit?: (data: MetadataValues) => void;
  onChange?: (data: MetadataValues) => void;
  disabled?: boolean;
  vertical: boolean;
  componentClass?: string;
  initialValuesSetter?: <V>(value: V) => boolean;
  className?: string;
  formRef?: RefObject<HTMLFormElement | null>;
  onInvalidSubmit?: () => void;
  updateOnSideEffect?: boolean;
  isSaveDisabled?: boolean;
};

const MetadataForm: FCC<Props> = (props) => {
  const {
    componentClass,
    vertical,
    disabled,
    onSubmit,
    onChange,
    children,
    initialValuesSetter,
    className,
    formRef,
    onInvalidSubmit,
    updateOnSideEffect,
    isSaveDisabled,
  } = props;
  const ComponentClass = componentClass ?? Form;

  const componentProps = isFunction(ComponentClass)
    ? {
        vertical,
        disabled,
        onValidSubmit: onSubmit,
        onChange,
        initialValuesSetter,
        submitByCommand: true,
        className,
        formRef,
        onInvalidSubmit,
        updateOnSideEffect,
        isSaveDisabled,
      }
    : {};

  return <ComponentClass {...componentProps}>{children}</ComponentClass>;
};

export default MetadataForm;
